var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#1A8C41",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3437 7.677C10.6771 7.677 7.67708 10.677 7.67708 14.3437C7.67708 18.0103 10.6771 21.0103 14.3437 21.0103C18.0104 21.0103 21.0104 18.0103 21.0104 14.3437C21.0104 10.677 18.0104 7.677 14.3437 7.677ZM17.1437 13.2103L13.9437 16.4103C13.6771 16.677 13.2771 16.677 13.0104 16.4103L11.5437 14.9437C11.2771 14.677 11.2771 14.277 11.5437 14.0103C11.8104 13.7437 12.2104 13.7437 12.4771 14.0103L13.4771 15.0103L16.2104 12.277C16.4771 12.0103 16.8771 12.0103 17.1437 12.277C17.4104 12.5437 17.4104 12.9437 17.1437 13.2103Z",
    fill: "#1A8C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4b3207479bee81b1262d6cd281ef291d.svg";
export { ForwardRef as ReactComponent };